export const assetStatuses = [
  'USE',
  'STOLEN',
  'RETURNED',
  'FOR_RETURN',
  'REQ_SENT',
  'REPLACED',
  'FOR_REPAIR',
  'LOST',
  'FURTHER_RENTAL',
  'DISCARDED',
  'FOR_DELIVERY',
  'CONTRACTED_EXT',
  'CANCELLED',
  'SOLD',
  'AVAILABLE',
  'BUYOUT',
  'REMARKETED',
] as const

export const assetTypes = [
  'TABLET',
  'SERVER_STORAGE_NETWORK',
  'SCREEN',
  'PC',
  'OTHER',
  'HEADSET',
  'DOCKING',
  'CONTRACT',
  'CAR_CHARGER',
  'BICYCLE',
  'AV_EQUIPMENT',
  'MOBILE_PHONE',
] as const

export const userTypes = [
  'AVAILABLE',
  'BUFFERSTOCK',
  'DISCHARGED',
  'EMPLOYEE',
  'GREENPOOL',
  'HOME_OFFICE',
  'POOL',
  'PROJECT',
  'LOCATION',
] as const

export const typeOptions = [
  { value: 'EMAIL', label: 'EMAIL' },
  { value: 'SMS', label: 'SMS' },
  { value: 'SYSTEM', label: 'SYSTEM' },
]

export const ownershipTypes = ['OWNED'] as const
export const returnStatuses = ['NONE', 'FOR_CONTROL', 'RETURNED', 'SELECTED'] as const
export const resultStatuses = ['A', 'B', 'C'] as const
